/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snackbar_Settingsupdated1Inputs */

const en_snackbar_settingsupdated1 = /** @type {(inputs: Snackbar_Settingsupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings updated successfully.`)
};

const de_snackbar_settingsupdated1 = /** @type {(inputs: Snackbar_Settingsupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen wurden erfolgreich aktualisiert.`)
};

/**
* | output |
* | --- |
* | "Settings updated successfully." |
*
* @param {Snackbar_Settingsupdated1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const snackbar_settingsupdated1 = /** @type {((inputs?: Snackbar_Settingsupdated1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snackbar_Settingsupdated1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_snackbar_settingsupdated1(inputs)
	return de_snackbar_settingsupdated1(inputs)
});
export { snackbar_settingsupdated1 as "snackbar_settingsUpdated" }